import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHboComponent } from './simple-icons-hbo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHboComponent ],
    exports:      [ SimpleIconsHboComponent ],
    bootstrap:    []
})
export class SimpleIconsHboModule {}
